/* ============================================================
   Mama Bub — Seat Belt Safety Quiz (no dependencies)
   One question at a time · progress · light scoring · result
   Collects NO personal info. Result always funnels to product.
   ============================================================ */
(function () {
  "use strict";

  var RESULTS = {
    high: {
      badgeClass: "qz-result__badge--high",
      badge: "⚠️ High Risk",
      urgency:
        "A crash gives you no warning — and no second chance to move the belt. Two minutes from now, this could already be fixed.",
      urgencyAlt:
        "A crash gives no warning — and no second chance to move the belt. Two minutes from now, this could already be fixed for her.",
      title: "Your baby may be riding in the danger zone.",
      text: "Your answers point to the exact setup doctors warn against — the lap belt sitting across your baby bump on everyday drives. Fetal injury risk can begin at just 16 mph: the school run, the parking lot, the intersection by your house. This isn’t a “fix it later” problem — it’s the moment you’ll never see coming. Mama Bub locks the belt low and safe in 2 minutes. Please don’t take one more drive with it where it is.",
      titleAlt: "Her baby may be riding in the danger zone.",
      textAlt:
        "The answers point to the exact setup doctors warn against — the lap belt sitting across her baby bump on everyday drives. Fetal injury risk can begin at just 16 mph, even on short trips. This isn’t something to leave for “someday.” Mama Bub locks the belt low and safe in 2 minutes — the kind of gift that quietly protects the people you love most.",
    },
    mid: {
      badgeClass: "qz-result__badge--mid",
      badge: "⚠️ At Risk",
      urgency:
        "You don’t get to schedule the drive where it matters. Make the safe position automatic before the next one.",
      urgencyAlt:
        "She doesn’t get to schedule the drive where it matters. Make the safe position automatic before her next one.",
      title: "You’re close — but “close” isn’t safe enough.",
      text: "You’re clearly trying — but holding the belt with one hand or hoping it stays put fails the instant you brake hard. In a crash there’s no second chance to reposition it, and you don’t get to choose when that happens. Mama Bub makes the correct, below-the-baby-bump position automatic, so your baby is protected on every single drive — not just the ones you remember.",
      titleAlt: "She’s close — but “close” isn’t safe enough.",
      textAlt:
        "She’s clearly trying — but holding the belt with one hand or hoping it stays put fails the instant she brakes hard. In a crash there’s no second chance to reposition it. Mama Bub makes the correct, below-the-baby-bump position automatic, so her baby is protected on every drive. A small gift that could mean everything.",
    },
    good: {
      badgeClass: "qz-result__badge--good",
      badge: "⚠️ Still Exposed",
      urgency:
        "A belt you position by hand is a belt that moves. One hard brake puts it right back over your baby — and you won’t get a warning first.",
      urgencyAlt:
        "A belt she positions by hand is a belt that moves. One hard brake puts it right back over the baby — with no warning first.",
      title: "Right instinct. Wrong equipment.",
      text: "You’re putting the belt low — that’s exactly where doctors say it belongs. Here’s the problem: a hand-positioned belt doesn’t stay there. It creeps back up over the baby bump on every drive, and in a sudden stop it loads wherever it happens to be sitting at that moment. You can’t hold a belt against crash force. Mama Bub anchors the safe position permanently — so being right once becomes being protected on every single drive.",
      titleAlt: "She has the right instinct — but nothing holding it.",
      textAlt:
        "She’s putting the belt low — exactly where doctors say it belongs. The problem: a hand-positioned belt doesn’t stay there. It creeps back up over the baby bump on every drive, and in a sudden stop it loads wherever it’s sitting at that moment. Mama Bub anchors the safe position permanently — so her good habit becomes guaranteed protection.",
    },
  };

  document.addEventListener("DOMContentLoaded", function () {
    var root = document.getElementById("qz-root");
    if (!root) return;

    var screens = Array.prototype.slice.call(
      root.querySelectorAll(".qz-screen"),
    );
    var questionScreens = screens.filter(function (s) {
      return s.hasAttribute("data-q");
    });
    var total = questionScreens.length;

    var progress = document.getElementById("qz-progress");
    var bar = document.getElementById("qz-progress-bar");
    var label = document.getElementById("qz-progress-label");
    var backBtn = document.getElementById("qz-back");
    var startBtn = document.getElementById("qz-start");

    var answers = new Array(total); // per-question score, avoids double-count on Back
    var current = -1; // -1 = intro
    var buyer = "self"; // Q0 choice: self | partner | gift — personalizes the result
    var nextDrive = ""; // Q3 choice: today | tomorrow | days | soon — arms the urgency line

    var DRIVE_LEADS = {
      self: {
        today: "Your baby's next car ride is today.",
        tomorrow: "Your baby's next car ride is tomorrow.",
        days: "Your baby's next car ride is just days away.",
        soon: "Your baby's next car ride could be any moment.",
      },
      her: {
        today: "Her baby's next car ride is today.",
        tomorrow: "Her baby's next car ride is tomorrow.",
        days: "Her baby's next car ride is just days away.",
        soon: "Her baby's next car ride could be any moment.",
      },
    };

    // --- Rotating safety-fact ticker (intro screen only) ---
    var FACTS = [
      "Car crashes are the #1 cause of traumatic injury to babies in the womb.",
      "170,000 pregnant women are involved in car crashes every year in the US.",
      "3,000 pregnancies are lost to car accidents every year — more than any illness.",
      "Fetal injury risk can begin at just 16 mph. That’s parking-lot speed.",
      "77% of pregnant drivers wear their seatbelt incorrectly — without knowing it.",
      "By the third trimester, a standard seatbelt no longer fits 62% of women safely.",
      "At 30 mph, a lap belt on the belly can load ~4,500 lbs of force onto the uterus.",
      "A wrongly positioned lap belt can raise placental abruption risk by up to 70%.",
    ];
    var ticker = document.getElementById("qz-ticker");
    var tickerFact = document.getElementById("qz-ticker-fact");
    var tickerDots = document.getElementById("qz-ticker-dots");
    var factIdx = 0;
    var tickerTimer = null;

    if (tickerDots) {
      FACTS.forEach(function (_, i) {
        var d = document.createElement("span");
        d.className = "qz-ticker__dot" + (i === 0 ? " is-on" : "");
        tickerDots.appendChild(d);
      });
    }

    function setDot(i) {
      if (!tickerDots) return;
      Array.prototype.forEach.call(tickerDots.children, function (d, j) {
        d.classList.toggle("is-on", j === i);
      });
    }

    function startTicker() {
      if (!ticker || !tickerFact) return;
      ticker.hidden = false;
      if (tickerTimer) return;
      tickerTimer = setInterval(function () {
        factIdx = (factIdx + 1) % FACTS.length;
        tickerFact.classList.add("is-fading");
        setTimeout(function () {
          tickerFact.textContent = FACTS[factIdx];
          setDot(factIdx);
          tickerFact.classList.remove("is-fading");
        }, 350);
      }, 4500);
    }

    function stopTicker() {
      if (!ticker) return;
      ticker.hidden = true;
      if (tickerTimer) {
        clearInterval(tickerTimer);
        tickerTimer = null;
      }
    }

    startTicker(); // intro is the first screen

    function showScreen(el) {
      screens.forEach(function (s) {
        s.classList.remove("is-active");
      });
      el.classList.add("is-active");
      if (root.scrollIntoView)
        root.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    function setProgress(qIndex) {
      if (qIndex < 0) {
        progress.hidden = true;
        return;
      }
      progress.hidden = false;
      label.textContent = "Question " + (qIndex + 1) + " of " + total;
      bar.style.width = ((qIndex + 1) / total) * 100 + "%";
    }

    // Rewrite question + option wording to match who they're buying for
    // (e.g. "where are you in your journey" → "where is she in her journey").
    function applyPronoun(screen) {
      var she = buyer === "partner" || buyer === "gift";
      var q = screen.querySelector(".qz-question");
      if (q && q.getAttribute("data-q-alt")) {
        if (!q.dataset.qSelf) q.dataset.qSelf = q.innerHTML;
        q.innerHTML = she ? q.getAttribute("data-q-alt") : q.dataset.qSelf;
      }
      screen
        .querySelectorAll(".qz-option__text[data-text-alt]")
        .forEach(function (el) {
          if (!el.dataset.textSelf) el.dataset.textSelf = el.innerHTML;
          el.innerHTML = she
            ? el.getAttribute("data-text-alt")
            : el.dataset.textSelf;
        });
    }

    function goToQuestion(i) {
      current = i;
      stopTicker();
      showScreen(questionScreens[i]);
      applyPronoun(questionScreens[i]);
      setProgress(i);
      backBtn.hidden = false;
    }

    // Raw max = 7 (Q1 stage max 2 + Q2 belt position max 5; Q0/Q3 score 0).
    // Belt position dominates: belly(5) → high even in 1st trimester;
    // one-hand/not-sure(3) → mid (matches the mid-tier copy); low(0) → good.
    function tierFromScore(s) {
      if (s >= 6) return "high";
      if (s >= 3) return "mid";
      return "good";
    }

    function showResult() {
      var score = answers.reduce(function (sum, v) {
        return sum + (v || 0);
      }, 0);
      var tier = tierFromScore(score);
      var data = RESULTS[tier];
      var resultScreen = document.getElementById("qz-result");
      progress.hidden = true;
      backBtn.hidden = true;
      showScreen(resultScreen);

      var loading = document.getElementById("qz-res-loading");
      var content = document.getElementById("qz-res-content");
      loading.hidden = false;
      content.hidden = true;

      // Every outcome reads high-risk: 9/10 for the worst tier, 8/10 for
      // everyone else. The tier still differentiates badge/title/copy, but
      // the meter never gives permission to leave.
      var display = tier === "high" ? 9 : 8;

      var she = buyer === "partner" || buyer === "gift";
      setTimeout(function () {
        var badge = document.getElementById("qz-res-badge");
        badge.className = "qz-result__badge " + data.badgeClass;
        badge.textContent = data.badge;

        var meter = document.getElementById("qz-meter");
        if (meter) {
          meter.hidden = false;
          document.getElementById("qz-meter-score").textContent =
            display + "/10 — High";
          var fill = document.getElementById("qz-meter-fill");
          fill.className = "qz-meter__fill qz-meter__fill--high";
          fill.style.width = "0%";
          setTimeout(function () {
            fill.style.width = display * 10 + "%";
          }, 80);
        }

        document.getElementById("qz-res-title").textContent = she
          ? data.titleAlt
          : data.title;
        document.getElementById("qz-res-text").textContent = she
          ? data.textAlt
          : data.text;
        var urgency = document.getElementById("qz-res-urgency");
        if (urgency) {
          var lead = (DRIVE_LEADS[she ? "her" : "self"] || {})[nextDrive] || "";
          urgency.textContent =
            (lead ? lead + " " : "") + (she ? data.urgencyAlt : data.urgency);
        }
        var cta = document.getElementById("qz-res-cta");
        if (cta)
          cta.textContent = she
            ? "Protect Her & Baby Now →"
            : "Protect My Baby Now →";
        loading.hidden = true;
        content.hidden = false;
      }, 2200);
    }

    // Start
    if (startBtn) {
      startBtn.addEventListener("click", function () {
        goToQuestion(0);
      });
    }

    // Back
    if (backBtn) {
      backBtn.addEventListener("click", function () {
        if (current <= 0) {
          current = -1;
          showScreen(document.getElementById("qz-intro"));
          setProgress(-1);
          backBtn.hidden = true;
          startTicker();
        } else {
          goToQuestion(current - 1);
        }
      });
    }

    // Options
    questionScreens.forEach(function (screen, qIdx) {
      var opts = screen.querySelectorAll(".qz-option");
      opts.forEach(function (opt) {
        opt.addEventListener("click", function () {
          opts.forEach(function (o) {
            o.classList.remove("is-selected");
          });
          opt.classList.add("is-selected");
          answers[qIdx] = parseInt(opt.getAttribute("data-score") || "0", 10);
          var b = opt.getAttribute("data-buyer");
          if (b) buyer = b;
          var d = opt.getAttribute("data-drive");
          if (d) nextDrive = d;
          setTimeout(function () {
            if (current >= total - 1) {
              showResult();
            } else {
              goToQuestion(current + 1);
            }
          }, 300);
        });
      });
    });
  });
})();
